/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {processInstrumentLinkResultEvents} from '../api'

export const useMutationProcessInstrumentLinkResultEvents = createReactQueryMutationHook('processInstrumentLinkResultEvents', processInstrumentLinkResultEvents)
